import { FormikErrors } from 'formik'

import MoneyField from 'modules/core/components/MoneyField'
import { fromCents, toCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import {
  BillingRateValues,
  ProjectManagementRateCreateInput,
} from 'modules/project_management/pages/ProjectDetailsPage/Employees/RatesSettingsSidepanel/types'

interface FlatBillRateProps {
  rate: ProjectManagementRateCreateInput
  onChange: (rates: ProjectManagementRateCreateInput[]) => void
  errors: FormikErrors<BillingRateValues>
}

const FlatBillRate = ({ rate, onChange, errors }: FlatBillRateProps) => {
  const error = errors?.rates?.[rate.resourceId]
  const rateError = typeof error === 'object' && error !== null ? error : undefined

  return (
    <MoneyField
      label={i18n.t('project_management.forms.billing_rate.fields.bill_rate')}
      mandatory
      currency={rate.currency}
      value={rate.billingRateCents ? fromCents(rate.billingRateCents).toString() : undefined}
      onChange={(value: string) => {
        onChange([
          {
            ...rate,
            billingRateCents: value.length && toCents(Number(value)),
            chargingCostCents: value.length && toCents(Number(value)),
          },
        ])
      }}
      placeholder="0"
      error={rateError?.billingRateCents}
    />
  )
}

export default FlatBillRate
